import React from "react";
import { Link } from "react-router-dom";
import logo from "@/assets/tmt-logo-white.png";
import { COMPANY } from "@/data/content";

export const Logo = ({ className = "", imgClassName = "h-14 w-auto sm:h-16", onClick }) => (
  <Link to="/" onClick={onClick} className={`inline-flex items-center ${className}`} aria-label={COMPANY.name}>
    <img src={logo} alt={COMPANY.name} className={imgClassName} />
  </Link>
);
